const tvRepairService = {
  title: "TV Repair",
  icon: "📺",
  rateCardKey: "tv",
  shortDescription:
    "TV startup issue, display checks, sound issue review, wall mount support, and installation.",
  longDescription:
    "Book TV support for startup issues, sound issues, basic display diagnosis, wall mounting support, and setup assistance.",
  consultationNote:
    "Panel issues, motherboard faults, and display-line problems generally require inspection first.",
  responsePromise:
    "Assignment depends on TV size, type, and actual issue nature.",
  warrantyPolicy:
    "Support depends on TV condition, panel health, and repair feasibility.",
  subServices: [
    {
      id: "tv-inspection",
      title: "TV Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for no display, no power, sound issue, or startup failure.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "tv-wall-mount",
      title: "TV Wall Mount Installation",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic wall mount fitting support for suitable TV sizes and wall conditions.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "tv-uninstallation",
      title: "TV Uninstallation",
      icon: "🔁",
      group: "Installation",
      description:
        "Safe removal support for mounted TV units.",
      basePrice: 349,
      priceType: "fixed",
      duration: "20-30 mins",
      warranty: "Visit completion only",
      unit: "job",
    },
    {
      id: "tv-sound-issue",
      title: "Sound / Speaker Issue Support",
      icon: "🔊",
      group: "Repair",
      description:
        "Diagnosis and basic support direction for TV sound-related issues.",
      basePrice: 349,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default tvRepairService;